import { render, staticRenderFns } from "./IconSvgPlusFill.vue?vue&type=template&id=5f62addd&scoped=true&"
import script from "./IconSvgPlusFill.vue?vue&type=script&lang=js&"
export * from "./IconSvgPlusFill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62addd",
  null
  
)

export default component.exports